module.exports = __webpack_public_path__ + "img/esmeralda-hotel-2.7814ac42.jpg";